/**
 * Client “leggeri”: app WebView, tablet/phone (anche Chrome “sito desktop”), poca RAM.
 * Session replay / tour / stories canvas su questi device fanno OOM.
 *
 * La stessa logica è inline in public/index.html (Hotjar parte prima di React):
 * se cambi i criteri, aggiorna anche lì.
 */
const mediaMatches = (query) => {
  try {
    return Boolean(window.matchMedia?.(query)?.matches);
  } catch (_) {
    return false;
  }
};

const readFromApp = () => {
  try {
    if (typeof localStorage !== 'undefined' && localStorage.getItem('fromApp')) return true;
  } catch (_) {
    /* private mode */
  }
  try {
    if (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('fromApp')) {
      return true;
    }
  } catch (_) {
    /* ignore */
  }
  return false;
};

const isTouchMobileOrTablet = () => {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;

  const ua = navigator.userAgent || '';
  if (/Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(ua)) return true;
  // iPadOS 13+ si spaccia per Macintosh
  if (navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1) return true;

  // Tablet/phone con “sito per computer”: lo UA è desktop, ma il puntatore è touch.
  if (mediaMatches('(hover: none) and (pointer: coarse)')) return true;
  if (mediaMatches('(hover: none) and (any-pointer: coarse)')) return true;

  const touchPoints = Number(navigator.maxTouchPoints) || 0;
  const shortSide = Math.min(window.screen?.width || 0, window.screen?.height || 0);
  // iPad / Android tablet anche in landscape (lato corto ≤ 1366).
  if (touchPoints > 1 && shortSide > 0 && shortSide <= 1366) return true;

  return false;
};

export const isLowMemoryDevice = () => {
  if (typeof navigator === 'undefined') return false;
  const memory = Number(navigator.deviceMemory);
  if (Number.isFinite(memory) && memory <= 2) return true;
  if (navigator.connection?.saveData) return true;
  // Tablet da 4 GB: Replay + calendario saturano comunque la WebView/Chrome.
  if (isTouchMobileOrTablet() && Number.isFinite(memory) && memory <= 4) return true;
  return false;
};

/** No LogRocket / Sentry Replay / Hotjar / Usetiful / canvas stories. */
export const isLightClient = () => {
  if (typeof window !== 'undefined' && window.__ZB_LIGHT_CLIENT__ === true) return true;
  return readFromApp() || isTouchMobileOrTablet() || isLowMemoryDevice();
};

export const shouldDisableHeavyTelemetry = isLightClient;
